import { Controller, useFormContext } from 'react-hook-form';
import { Input, Label, FormGroup } from '@polichat/flamboyant';
import { FINANCIAL_OPTIONS } from '../useFinishChatForm';
import { useGlotaT } from 'src/hooks/useGlotaTranslation';
import { useMemo } from 'react';
import styles from '../styles.module.css';

export function FinancialForm() {
  const { control } = useFormContext();

  // Traduções para opções financeiras
  const secondViaText = useGlotaT(
    'spa.chat.finishChat.financial.secondVia.label'
  );
  const cancellationText = useGlotaT(
    'spa.chat.finishChat.financial.cancellation.label'
  );
  const othersText = useGlotaT('spa.chat.finishChat.financial.other.label');

  // Opções traduzidas
  const translatedFinancialOptions = useMemo(
    () =>
      FINANCIAL_OPTIONS.map((opt) => {
        let label = opt.label;
        if (opt.value === 'second_via') label = secondViaText;
        else if (opt.value === 'cancellation') label = cancellationText;
        else if (opt.value === 'other') label = othersText;
        return { ...opt, label };
      }),
    [secondViaText, cancellationText, othersText]
  );

  return (
    <div
      className={styles.fieldContainer}
      data-testid="finish-chat-financial-container"
    >
      <Controller
        name="financial"
        control={control}
        render={({ field, fieldState }) => (
          <>
            <FormGroup tag="fieldset">
              {translatedFinancialOptions.map((option) => (
                <FormGroup check key={option.value}>
                  <Input
                    type="radio"
                    id={option.value}
                    name="financial"
                    value={option.value}
                    checked={field.value === option.value}
                    onChange={field.onChange}
                    data-testid={`finish-chat-financial-option-${option.value}`}
                  />
                  <Label
                    check
                    htmlFor={option.value}
                    data-testid={`finish-chat-financial-label-${option.value}`}
                  >
                    {option.label}
                  </Label>
                </FormGroup>
              ))}
            </FormGroup>
            {/* Error */}
            {fieldState?.error?.message && (
              <span
                className={styles.fieldError}
                data-testid="finish-chat-financial-error"
              >
                {fieldState?.error?.message}
              </span>
            )}
          </>
        )}
      />
    </div>
  );
}
